/*
 * Copyright © 2023 - Zimproov.
 * All rights reserved.
 */

export { parseLegacyZaq } from "./zaq-parser";
export { getLegacyZaqConfig } from "./config";
